module.exports = __webpack_public_path__ + "static/8-25d7af1ad617234ece1b1012c1692738.png";